import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

class UploadModal extends Component {
    constructor (props) {
        super(props);
        this.state = {
            fileNames: [],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit (event) {
        event && event.preventDefault();
        if (this.state.fileNames.length) {
            this.props.onSubmitCsv(event.target.elements.csv.files);
        }
    }

    render () {
        return (<Modal animation={false}
            bsSize="large"
            show={true}
            onHide={this.props.toggleModal}>
                <Modal.Header>
                    <Modal.Title>Upload CSV Document</Modal.Title>
                </Modal.Header>
                <form onSubmit={this.handleSubmit}>
                    <Modal.Body>
                        <div className="form-bg" id="filter-modal">

                            <div className="input-group">
                                <span className="input-group-btn">
                                    <button type="button" id="upload"
                                        className="btn btn-primary"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            document.getElementById('csv').click();
                                        }}>

                                        Select File &hellip;
                                    </button>
                                </span>
                                <input id="fileNamePreview"
                                    className="form-control"
                                    readOnly
                                    value={this.state.fileNames.join()}
                                />
                            </div>

                            {/*
                                @TODO: list errors
                            */}

                            <input id="csv" type="file" multiple className="hidden" accept=".csv"
                                onChange={(event) => {
                                    // @TODO: Ensure the file has a .csv
                                    let files = []
                                    for (let i = 0; i < event.target.files.length; i++) {
                                        files.push(event.target.files[i].name.split(/(\\|\/)/g))
                                    }
                                    this.setState({
                                        fileNames: files
                                    });
                                }}
                                name="csv"/>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        {/* todo: cancel button not working */}
                        {/* <button className="btn btn-default" onClick={() => {this.props.toggleModal}}>Cancel</button> */}
                        <button className="btn btn-primary" type="submit">
                            <i className="fa fa-upload"/> Upload
                        </button>
                    </Modal.Footer>
                </form>
        </Modal>);
    }
}

UploadModal.propTypes = {};

export default UploadModal;
